import React from "react";
import {
    FormLayout,
    HeaderActions,
    Heading,
    Input,
    LoadingProgress,
    Panel,
    Switch,
    Text,
} from "@/ui";
import { Icon } from "@/components";
import { useFormActions, useForm, useMeta, useValidator } from "@/hooks";
import {
    MUTATION_UPDATE_WEBPAY_APP,
    QUERY_LIST_STORE_APPS,
} from "../../apollo/module-operations/app";
import _ from "lodash";
import styles from "./GeneralsForm.module.scss";

const SaveIcon = () => <Icon icon="save" />;

const fieldError = (validator, name) =>
    validator?.[name]?.isInvalid ? validator[name].message : undefined;

const WebPayForm = ({ app }) => {
    const { user } = useMeta();
    const { inputs, setInputs, inputChange } = useForm();

    if (!_.get(inputs, "id", null)) {
        setInputs(app);
    }

    const options = {
        variables: {
            account_id: user.accountId,
            store_id: user.storeId,
            input: {
                ...inputs,
                sandbox: inputs.sandbox ? true : false,
                type: "WebPay",
            },
        },
    };

    const { validator, isValid, isSubmited } = useValidator(
        [
            {
                field: "test_commerce_code",
                method: "isEmpty",
                validWhen: false,
                message: "This Commerce Code is required.",
            },
            {
                field: "commerce_code",
                method: "isEmpty",
                validWhen: false,
                message: "This Commerce Code is required.",
            },
            {
                field: "test_secret_key",
                method: "isEmpty",
                validWhen: false,
                message: "This Secret Key is required.",
            },
            {
                field: "secret_key",
                method: "isEmpty",
                validWhen: false,
                message: "This Secret Key is required.",
            },
        ],
        {
            ...inputs,
        },
    );

    const { createOrUpdate, loading } = useFormActions(
        "id",
        "WebPay",
        "",
        MUTATION_UPDATE_WEBPAY_APP,
        [
            {
                query: QUERY_LIST_STORE_APPS,
                variables: {
                    account_id: user.accountId,
                    store_id: user.storeId,
                },
            },
        ],
        options,
        "",
        isValid,
        isSubmited,
        "secondary",
    );

    const commerceCodeField = inputs.sandbox
        ? "test_commerce_code"
        : "commerce_code";
    const secretKeyField = inputs.sandbox ? "test_secret_key" : "secret_key";

    return (
        <Panel
            className={styles.root}
            header={
                <div className={styles.headerBar}>
                    <div className={styles.headerText}>
                        <Heading level={4}>WebPay</Heading>
                        <Text tone="secondary" variant="body-sm">
                            WebPay Information
                        </Text>
                    </div>
                    <HeaderActions
                        actions={[
                            {
                                id: "update",
                                label: "Update",
                                icon: loading ? undefined : <SaveIcon />,
                                loading,
                                disabled: loading,
                                onClick: () => createOrUpdate(),
                            },
                        ]}
                        aria-label="WebPay actions"
                    />
                </div>
            }
            showHeaderDivider
        >
            {user.loading ? (
                <div className={styles.loading}>
                    <LoadingProgress
                        indeterminate
                        indicator="circular"
                        size="sm"
                        title="Loading"
                    />
                </div>
            ) : (
                <FormLayout>
                    <FormLayout.Section title="Information">
                        <Switch
                            checked={Boolean(inputs.sandbox)}
                            label="Test Mode"
                            name="sandbox"
                            onChange={inputChange}
                        />
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, commerceCodeField)}
                                fullWidth
                                label="Commerce Code"
                                name={commerceCodeField}
                                onChange={inputChange}
                                value={inputs[commerceCodeField] || ""}
                            />
                        </FormLayout.Grid>
                        <FormLayout.Grid columns={2} maxWidth="twoThirds">
                            <Input
                                error={fieldError(validator, secretKeyField)}
                                fullWidth
                                label="Secret Key"
                                name={secretKeyField}
                                onChange={inputChange}
                                value={inputs[secretKeyField] || ""}
                            />
                        </FormLayout.Grid>
                    </FormLayout.Section>
                </FormLayout>
            )}
        </Panel>
    );
};

export default WebPayForm;
